exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-label[_v-fe2b96b2]{padding:4px 0}.profile-textfield[_v-fe2b96b2]{margin-top:-20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-fe2b96b2&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/forms/EditPasswordForm.vue
// module id = 325
// module chunks = 0